module.exports = __webpack_public_path__ + "static/media/B2.a3ef902d.png";